{
  "title": {
    "documents": "Barcha hujjatlar",
    "reports": "Barcha hisobotlar"
  },
  "sections": {
    "label": "Bo'limlar",
    "documents": "Hujjatlar",
    "reports": "Hisobotlar"
  },
  "search": "Qidirish",
  "views": {
    "label": "Ko'rinish",
    "table": "Jadval",
    "grid": "Karta",
    "columns": "Ustunlar"
  },
  "create": {
    "button": "Yaratish",
    "folder": "Papka yaratish",
    "upload": "Hujjat yuklash"
  },
  "columns": {
    "name": "Nomi",
    "type": "Turi",
    "size": "Hajmi",
    "createdAt": "Yaratilgan",
    "updatedAt": "O’zgartirilgan",
    "createdBy": "Yaratuvchi",
    "visibility": "Ko’rinishi",
    "actions": "Harakat"
  },
  "types": {
    "folder": "Jild",
    "pdf": "Pdf",
    "word": "Word",
    "excel": "Excel",
    "powerpoint": "PowerPoint",
    "image": "Rasm",
    "csv": "CSV",
    "other": "Boshqa"
  },
  "visibility": {
    "private": "Shaxsiy",
    "selected": "Tanlanganlar",
    "public": "Ommaviy",
    "sharedCount": "{{count}} foydalanuvchi"
  },
  "visibilityOption": {
    "private": "Shaxsiy hujjat",
    "selected": "Tanlanganlar",
    "public": "Ommaviy"
  },
  "visibilityHint": {
    "private": "Faqat siz va administratorlar ko'radi",
    "selected": "Siz, administratorlar va tanlangan foydalanuvchilar ko'radi",
    "public": "Bo'limni ko'rish huquqi bor barcha xodimlar ko'radi"
  },
  "sort": {
    "label": "Saralash",
    "name": "Nomi (A–Z)",
    "-name": "Nomi (Z–A)",
    "-updatedAt": "Oxirgi o'zgartirilganlar",
    "updatedAt": "Avval o'zgartirilganlar",
    "-createdAt": "Yangi yaratilganlar",
    "createdAt": "Avval yaratilganlar",
    "-size": "Hajmi: kattadan kichikka",
    "size": "Hajmi: kichikdan kattaga",
    "type": "Turi bo'yicha",
    "-type": "Turi bo'yicha (teskari)",
    "asc": "o'sish tartibida saralangan",
    "desc": "kamayish tartibida saralangan",
    "by": "{{column}} bo'yicha saralash"
  },
  "grid": {
    "files": "{{count}} ta fayl",
    "author": "Yaratdi: {{name}}",
    "edited": "Tahrirlandi: {{date}}"
  },
  "actions": {
    "menu": "Amallar",
    "open": "Ochish",
    "download": "Yuklab olish",
    "rename": "Nomini o'zgartirish",
    "move": "Ko'chirish",
    "visibility": "Ko'rinishni o'zgartirish",
    "delete": "O'chirish"
  },
  "inFolder": "{{folder}}",
  "rootFolder": "{{section}} (asosiy papka)",
  "upload": {
    "title": "Hujjat yuklash",
    "subtitle": "Tizimga yangi hujjat yuklash",
    "drop": "Hujjat yuklash",
    "dropActive": "Faylni shu yerga tashlang",
    "hint": "{{types}} - {{size}} gacha",
    "uploading": "Yuklanmoqda...",
    "uploadingProgress": "Yuklanmoqda... {{percent}}%",
    "addMore": "Yana hujjat qo'shish",
    "name": "Hujjat nomi",
    "folder": "Papka",
    "visibility": "Ko‘rinuvchanlik darajasi",
    "users": "Foydalanuvchilar",
    "usersPlaceholder": "Foydalanuvchilarni tanlang",
    "usersEmpty": "Foydalanuvchi topilmadi",
    "usersRequired": "Kamida bitta foydalanuvchini tanlang",
    "removeFile": "«{{name}}» faylini olib tashlash",
    "downloadFile": "«{{name}}» faylini yuklab olish",
    "saved_one": "Hujjat yuklandi",
    "saved_other": "{{count}} ta hujjat yuklandi",
    "savedText": "«{{folder}}» papkasiga qo'shildi",
    "rejectedType": "«{{name}}» — bu turdagi fayl qabul qilinmaydi",
    "rejectedSize": "«{{name}}» — fayl hajmi {{size}} dan katta",
    "failed": "«{{name}}» yuklanmadi",
    "pageDrop": "Yuklash uchun fayllarni shu yerga tashlang"
  },
  "folder": {
    "createTitle": "Papka yaratish",
    "createSubtitle": "{{section}} bo'limida yangi papka",
    "name": "Papka nomi",
    "namePlaceholder": "Masalan: 2026 yildagi hisobotlar",
    "created": "Papka yaratildi"
  },
  "rename": {
    "title": "Nomini o'zgartirish",
    "name": "Nomi",
    "saved": "Nomi o'zgartirildi"
  },
  "move": {
    "title": "Ko'chirish",
    "subtitle": "«{{name}}» uchun yangi joy",
    "target": "Papka",
    "saved": "Ko'chirildi"
  },
  "visibilityModal": {
    "title": "Ko'rinishni o'zgartirish",
    "saved": "Ko'rinish o'zgartirildi"
  },
  "delete": {
    "documentTitle": "Hujjat o'chirilsinmi?",
    "documentText": "«{{name}}» hujjati o'chiriladi.",
    "folderTitle": "Papka o'chirilsinmi?",
    "folderText": "«{{name}}» papkasi o'chiriladi.",
    "folderTextNonEmpty": "«{{name}}» papkasi ichidagi {{documents}} ta fayl va {{folders}} ta papka bilan birga o'chiriladi.",
    "done": "O'chirildi"
  },
  "access": {
    "title": "Kirish huquqi",
    "count": "{{count}} ta",
    "author": "Muallif",
    "view": "Ko'rish",
    "unknown": "Noma’lum foydalanuvchi"
  },
  "columnsView": {
    "meta": "{{type}} hujjat - {{size}}",
    "download": "{{ext}} yuklab olish",
    "noPreview": "Bu turdagi faylni ko'rib bo'lmaydi"
  },
  "preview": {
    "download": "Yuklab olish",
    "frame": "«{{name}}» hujjatining ko'rinishi"
  },
  "empty": {
    "documents": "Hujjatlar mavjud emas",
    "reports": "Hisobotlar mavjud emas",
    "text": "Hali hujjat yo'q. «Hujjat yuklash» tugmasini bosing.",
    "textReadonly": "Bu yerda hali hujjat yo'q.",
    "folderTitle": "Papka bo'sh",
    "folderText": "Bu papkada hali hujjat yo'q.",
    "searchTitle": "Hech narsa topilmadi",
    "searchText": "«{{q}}» bo'yicha natija yo'q.",
    "clear": "Tozalash"
  },
  "notFound": {
    "title": "Papka topilmadi",
    "text": "Papka o'chirilgan yoki sizga ko'rinmaydi.",
    "back": "Bosh papkaga qaytish"
  },
  "error": {
    "load": "Ma'lumotlarni yuklab bo'lmadi",
    "retry": "Qayta urinish",
    "generic": "Xatolik yuz berdi"
  },
  "common": {
    "cancel": "Bekor qilish",
    "save": "Saqlash",
    "close": "Yopish",
    "breadcrumbs": "Papka yo'li",
    "dash": "-"
  }
}
